// Mapa único de íconos por categoría de producto para tickets, compras y ventas.
import {
    Headphones,
    Package,
    Router,
    Signal,
    Smartphone,
    Tag,
    Wrench,
    type LucideIcon,
} from 'lucide-react';
import type { SaleLine } from '@/api/services/retail-wizard/contract';
import { lineCategoryKey, UNCATEGORIZED_LINE, type LineCategoryKey } from './ticketSummary';

export const CATEGORY_ICON: Record<LineCategoryKey, LucideIcon> = {
    PHONE: Smartphone,
    SIM: Signal,
    MODEM: Router,
    ACCESSORY: Headphones,
    BUNDLE: Package,
    SERVICE: Wrench,
    [UNCATEGORIZED_LINE]: Tag,
};

export function CategoryIcon({
    category,
    className = 'size-4',
}: {
    category: LineCategoryKey;
    className?: string;
}) {
    const Icon = CATEGORY_ICON[category];
    return <Icon className={className} aria-hidden />;
}

/** Ícono de una línea del ticket por su categoría. */
export function lineIcon(line: SaleLine) {
    return <CategoryIcon category={lineCategoryKey(line)} />;
}
